import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import _ from 'lodash';

import { CustomCheckbox } from '../CustomCheckbox/CustomCheckbox';

import { TableEditIcon } from 'src/assets';
import './customTable.scss';

export const CustomTable = (props) => {
  const { build, data, columns, styledByStatus = false, withCheckbox = true } = props;

  const { main_route } = build;

  // const navigate = useNavigate();

  const [selectedRows, setSelectedRows] = useState([]);

  const onSelectAll = useCallback(() => {
    if (selectedRows?.length) {
      return setSelectedRows([]);
    }
    setSelectedRows(data);
  }, [data, selectedRows]);

  const onSelectSingle = useCallback(
    (item) => () => {
      const isChecked = selectedRows?.find((row) => row.id === item.id);

      if (isChecked) {
        const updatedRows = _.reject(selectedRows, (row) => row.id === item.id);

        return setSelectedRows(updatedRows);
      }

      setSelectedRows((prev) => [...prev, item]);
    },
    [selectedRows],
  );

  // const onClickEdit = useCallback(
  //   (item) => () => {
  //     navigate(`${main_route}/${item.id}/edit`);
  //   },
  //   [main_route, navigate],
  // );

  return (
    <div className="custom-table__wrapper">
      <table className="custom-table">
        <thead>
          <tr>
            {withCheckbox ? (
              <th>
                <CustomCheckbox
                  isChecked={selectedRows?.length === data?.length}
                  onChange={onSelectAll}
                />
              </th>
            ) : null}
            {columns?.map((item, index) => (
              <th key={index} style={{ width: item?.key === 'id' ? 50 : 'auto' }}>
                {item.label}
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => {
            const tdStyles = classNames({
              'custom-table__row--pending':
                item.status?.toLowerCase() === 'pending' && styledByStatus,
              'custom-table__row--rejected':
                item.status?.toLowerCase() === 'cancel' && styledByStatus,
              'custom-table__row--accepted':
                ['complete', 'paid'].includes(item.status?.toLowerCase()) && styledByStatus,
              'custom-table__row--draft':
                (item.status?.toLowerCase() === 'draft' && styledByStatus) || !styledByStatus,
            });

            const isChecked = selectedRows?.find((row) => row.id === item.id);

            return (
              <tr key={item.id}>
                {withCheckbox ? (
                  <td className={tdStyles}>
                    <CustomCheckbox
                      id={item.id}
                      isChecked={!_.isEmpty(isChecked)}
                      onChange={onSelectSingle(item)}
                    />
                  </td>
                ) : null}
                {columns.map((column) => {
                  const value =
                    typeof column.value === 'function' ? column.value(item) : item?.[column?.key];

                  return (
                    <td key={item.id + column.id} className={item.status ? tdStyles : ''}>
                      {value}
                    </td>
                  );
                })}
                <td className={tdStyles} style={{ textAlign: 'right' }}>
                  <Link to={`${main_route}/${item.id}/edit`}>
                    <img src={TableEditIcon} alt={TableEditIcon} />
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
